import styled from "styled-components";
import { typography } from "../../../base/styled/typography.style";
import { colors } from "../../../base/styled/variables.styled";
export const OptionsList = styled.div `
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 8px 0 4px 0;

	.filter-accordion__show-more {
		display: inline-flex;
		align-self: flex-start;
		justify-content: flex-start;
		width: auto;
		max-width: none;
		span {
			color: ${colors.brand500};
		}
	}
`;
export const FilterAccordionTitle = styled.h4 `
	${typography.headline4};
	margin: 0 0 24px 0;
`;
export const FilterAccordionWrapper = styled.div `
	padding: 0;

	.cmp-accordion {
		border-radius: 0;
		background: ${colors.neutral000};
		overflow: hidden;
		gap: 0;
	}

	.cmp-accordion__item {
		border: 0;
		border-radius: 0;
		background: ${colors.neutral000};
		>div {
			border-radius: 0;
		}
		border-top: 2px solid ${colors.brand75};
		border-bottom: 2px solid ${colors.brand75};
	}

	.cmp-accordion__item > div[aria-expanded] {
		padding: 16px 20px;
		background: ${colors.neutral000};
		transition: background-color 0.2s ease, border-color 0.2s ease, border-width 0.2s ease, color 0.2s ease;
		border: 2px solid transparent;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.cmp-accordion__item > div[aria-expanded="false"]:hover {
		background: ${colors.brand75};
	}
	.cmp-accordion__item > div[aria-expanded="false"]:active {
		background: ${colors.brand75};
	}
	.cmp-accordion__item > div[aria-expanded="false"]:focus,
	.cmp-accordion__item > div[aria-expanded="false"]:focus-visible,
	.cmp-accordion__item > div[aria-expanded="false"].pseudo-focus-visible {
		outline: none;
		border: 3px solid ${colors.azulBordaFocus};
		background: ${colors.brand75};
	}
	.cmp-accordion__item > div[aria-expanded="false"] span,
	.cmp-accordion__item > div[aria-expanded="false"]:active span {
		color: ${colors.neutral800};
	}
	.cmp-accordion__item > div[aria-expanded="false"]:hover span,
	.cmp-accordion__item > div[aria-expanded="false"]:focus span,
	.cmp-accordion__item > div[aria-expanded="false"]:focus-visible span,
	.cmp-accordion__item > div[aria-expanded="false"].pseudo-focus-visible span {
		color: ${colors.brand500};
	}
	.cmp-accordion__item > div[aria-expanded="false"]:hover svg,
	.cmp-accordion__item > div[aria-expanded="false"]:focus svg,
	.cmp-accordion__item > div[aria-expanded="false"]:focus-visible svg,
	.cmp-accordion__item > div[aria-expanded="false"].pseudo-focus-visible svg {
		fill: ${colors.brand500};
	}

	.cmp-accordion__panel {
		background: ${colors.neutral000};
		border-top: 1px solid ${colors.brand75};
		padding: 16px 20px !important;
	}

	.cmp-accordion__item > div[aria-expanded="true"] {
		background: ${colors.neutral000};
	}
	.cmp-accordion__item > div[aria-expanded="true"] span {
		color: ${colors.brand500};
	}
`;
//# sourceMappingURL=FilterAccordion.style.js.map